import type { Profile } from '../types/database';

/** Personal events org label — always uses profile username (`full_name`), never email. */
export function getOwnerEventsOrgDisplayName(
  profile: Pick<Profile, 'full_name'> | null | undefined,
): string {
  const username = profile?.full_name?.trim();
  return username ? `${username}'s Events` : 'My Events';
}

export function resolveOrganizationDisplayName(
  org: { name: string; role: string },
  profile: Pick<Profile, 'full_name'> | null | undefined,
): string {
  if (org.role === 'owner') {
    return getOwnerEventsOrgDisplayName(profile);
  }
  return org.name;
}
